import React from 'react';
import { EmailSignup } from './EmailSignup';

export function HeroSection() {
  return (
    <div className="tw-flex">
      <div className='tw-flex-1'>
        <div className="tw-flex tw-relative tw-flex-col tw-grow tw-items-start tw-px-4 md:tw-px-20 tw-pt-5 tw-pb-28">
          <img
            loading="lazy"
            src="https://expertpeople.imgix.net/assets/images/hero-forbrands-rigth.png?auto=format"
            alt="Sustainable fashion background"
            className="tw-hidden md:tw-block tw-object-cover tw-absolute tw-inset-0"
            style={{ width: "100%", height: "680px" }}
          />
          <img
            loading="lazy"
            src="https://expertpeople.imgix.net/assets/images/hero-forbrands-rigth.png?auto=format"
            alt="Sustainable fashion background"
            className="md:tw-hidden tw-object-cover tw-absolute tw-inset-0"
            style={{ width: "100%", height: "550px" }}
          />
          <img
            loading="lazy"
            src="https://expertpeople.imgix.net/assets/images/solvy-logo-white.png"
            alt="Solvy logo"
            className="tw-object-contain tw-z-10"
            style={{ width: "75px" }}
          />
          <div className="tw-flex tw-relative tw-flex-col tw-mt-20 md:tw-mt-32" style={{ maxWidth: "763px" }}>
            <h1 className="tw-text-5xl md:tw-text-6xl tw-text-white tw-font-inter" style={{ fontFamily: 'Inter' }}>
              Even Ethical, Sustainable Brands Struggle With Excess. We're here to help.
            </h1>
            <p className="tw-mt-4 tw-text-3xl tw-leading-10 tw-font-normal tw-text-white" style={{ fontFamily: 'Inter', maxWidth: '623px' }}>
              Sell overstock, donate outright or develop custom one-of-a-kind pieces for a cause
            </p>
            <EmailSignup />
          </div>
        </div>
      </div>
      <div
        className='tw-hidden md:tw-block tw-ml-px'
        style={{ width: "481px" }}>
        <img
          loading="lazy"
          src="https://expertpeople.imgix.net/assets/images/hero-forbrands-left.png?auto=format,compress"
          alt="Sustainable fashion showcase"
          className="tw-object-contain tw-grow"
          style={{ height: "680px" }}
        />
      </div>
    </div>
  );
}

